import React from 'react';
import block from 'bem-cn-lite';
import { PropTypes } from 'prop-types';

import I18N from '../../common/i18n';
import SectionList from '../common/SectionList';
import { Button } from '../../common/components';
import { AppSections, Sections } from '../../common/enums';
import DropDownContainer from '../../common/components/DropDownContainer';
import icons from '../../common/icons';
import { getSectionLinkBody } from '../../../base/utils';

const b = block('ListSection');

export default
class UserList extends React.PureComponent {
  static title = I18N.USERS_LIST_TITLE

  static propTypes = {
    manifestId: PropTypes.number,
    itemElement: PropTypes.func,
    crud: PropTypes.object,
  }

  render() {
    return (
      <div className={b()}>
        <div className={b('Controls')}>
          <Button
            to={`/${AppSections.CATALOG}/${Sections.USERS}/new`}
            className={b('Button')}
            rightHint={I18N.USERS_ADD_BUTTON_HINT}
          >{I18N.USERS_ADD_BUTTON}</Button>
          <DropDownContainer>
            <Button
              icon={icons.COMMON_DELETE}
              to={`${getSectionLinkBody(this.props.manifestId)}${Sections.USERS}/delete`}
            >{I18N.MISC_DELETE_MULTIPLE}</Button>
          </DropDownContainer>
        </div>
        <SectionList
          queries={this.props.crud}
          itemElement={this.props.itemElement}
        />
      </div>
    );
  }
}
